export default "/asset/tutorial-page4.48d25367.png";